export const appVersion = { version: '3241654' };
